import React from 'react';
import { useAccountingCycleUrl } from '../useAccountingCycleRouting';
import { LinkButton } from 'framework/ui/ui-builder';

const ViewAccountingCycleButton = (props: any) => {
  const { getSingleEntityUrl } = useAccountingCycleUrl();

  return (
    <LinkButton url={getSingleEntityUrl} key="view-фccounting-сycle-entry" outline {...props}>
      View
    </LinkButton>
  );
};

export default ViewAccountingCycleButton;
